// src/pages/Mypage.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../assets/css/common.css';
import styles from '../assets/css/mypage.module.css';
import authService from '../services/authService';
import { memberService } from '../services/memberService';
import { registrationCheckService } from '../services/registrationCheckService';
import { documentService } from '../services/documentService';

function Mypage() {

  const [name, setName] = useState('');
  const [userRole, setUserRole] = useState(null);
  const [roleName, setRoleName] = useState('');
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [pendingDocuments, setPendingDocuments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchUserName = async () => {
    try {
      const data = await memberService.getRegistration({});
      if (data.formData?.name) {
        setName(data.formData.name);
      }
    } catch (error) {
      console.error('ユーザー情報取得エラー:', error);
    }
  };

  const fetchRegistrationStatus = async () => {
    try {
      const data = await registrationCheckService.checkRegistration();
      setRegistrationStatus(data);
    } catch (error) {
      console.error('登録状態確認エラー:', error);
    }
  };

  // 改訂により再署名が必要になった書面
  const fetchPendingDocuments = async () => {
    try {
      const data = await documentService.getPending();
      setPendingDocuments(data.pending || []);
    } catch (error) {
      console.error('再署名対象取得エラー:', error);
    }
  };

  fetchUserName();
  fetchRegistrationStatus();
  fetchPendingDocuments();
}, []);

  useEffect(() => { 
    const role = localStorage.getItem('userRole');
    const roleNameFromStorage = localStorage.getItem('userRoleName');
    
    setUserRole(parseInt(role, 10));
    setRoleName(roleNameFromStorage || '');
  }, []);
  
  const isAdmin = () => {
    return userRole === 1 || userRole === 2 || userRole === 3;
  };
  
  const isBranchManager = () => {
    return userRole === 4;
  };

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };
  return (
    <div className={styles.container}>
      <div className={`${styles["mypage-card"]}`}>
        <h1 className={styles["text-primary"]}>マイページ</h1>
        <div className={styles["user-info"]}>
          <h2>
            こんにちは、<span id="user-name">{name}</span>さん
          </h2>
          <p className={styles["role-info"]}>
            ロール: <span className={styles["role-name"]}>{roleName}</span>
          </p>
        </div>

        {pendingDocuments.length > 0 && (
          <div className="alert alert-warning text-center mb-3" style={{fontSize:'0.9rem'}}>
            書面が改訂されました。内容をご確認のうえ、再度ご署名をお願いします。
            {pendingDocuments.map((doc) => (
              <div key={doc.docKey} className="mt-1">
                <Link to={`/documents/${doc.docKey}/resign`} style={{fontWeight:'bold'}}>
                  {doc.title}（v{doc.signedVersion} → v{doc.currentVersion}）を確認して署名する
                </Link>
              </div>
            ))}
          </div>
        )}
        {registrationStatus && !registrationStatus.hasConfidentialityData && (
          <div className="alert alert-warning text-center mb-3" style={{fontSize:'0.9rem'}}>
            {!registrationStatus.hasMemberData && '会員情報が未登録です。'}
            {registrationStatus.hasMemberData && !registrationStatus.hasRouteData && '交通経路が未登録です。'}
            {registrationStatus.hasRouteData && !registrationStatus.hasPhotoData && '写真許可が未登録です。'}
            {registrationStatus.hasPhotoData && !registrationStatus.hasConfidentialityData && '機密保持同意が未登録です。'}
          </div>
        )}
        {registrationStatus && registrationStatus.hasConfidentialityData && (
          registrationStatus.hasChangedPassword ? (
            <div className="alert alert-success text-center mb-3" style={{fontSize:'0.9rem'}}>
              すべての登録が完了しています。
            </div>
          ) : (
            <div className="alert alert-warning text-center mb-3" style={{fontSize:'0.9rem'}}>
              登録は完了しています。セキュリティのため、初期パスワードを変更してください。<br/>
              <Link to="/change-password" style={{fontWeight:'bold'}}>パスワードを変更する</Link>
            </div>
          )
        )}

        <div className={styles["button-group"]}>
          {/* 管理者専用ボタン */}
          {isAdmin() && (
            <>
              <Link to="/branch-list" className={`${styles.btn} ${styles["btn-cute"]}`}>
                支社一覧
              </Link>
              <Link to="/member-list" className={`${styles.btn} ${styles["btn-cute"]}`}>
                全メンバー一覧
              </Link>
              <Link to="/admin/member-registration" className={`${styles.btn} ${styles["btn-cute"]}`}>
                メンバー登録
              </Link>
              <Link to="/admin/existing-member-registration" className={`${styles.btn} ${styles["btn-cute"]}`}>
                既存メンバー登録
              </Link>
              <Link to="/admin/documents" className={`${styles.btn} ${styles["btn-cute"]}`}>
                書面管理
              </Link>
            </>
          )}
          
          {/* 支社長専用ボタン */}
          {isBranchManager() && (
            <>
              <Link to="/member-list" className={`${styles.btn} ${styles["btn-cute"]}`}>
                支社メンバー一覧
              </Link>
            </>
          )}
          
          {/* 全員に表示するボタン */}
          <Link to="/member-registration-confirm-mypage" className={`${styles.btn} ${styles["btn-cute"]}`}> 
            登録内容確認
          </Link>
          <Link to="/route-confirm-mypage" className={`${styles.btn} ${styles["btn-cute-secondary"]}`}>
            交通経路確認
          </Link>
          <Link to="/qualifications" className={`${styles.btn} ${styles["btn-cute-secondary"]}`}>
            資格取得報告
          </Link>
          <Link to="/consents" className={`${styles.btn} ${styles["btn-cute-secondary"]}`}>
            同意・誓約
          </Link>
          <Link to="/change-password" className={`${styles.btn} ${styles["btn-cute-secondary"]}`}>
            パスワード変更
          </Link>

          <button onClick={handleLogout} className={`${styles.btn} ${styles["btn-cute-secondary"]}`}>
            ログアウト
          </button>
        </div>
      </div>
    </div>
  );
}

export default Mypage;
